;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export interface SubmenuPathMatch {
  url: string;
  inactive?: boolean;
  isPathActive?: (pathname: string) => boolean;
}

function isAbsoluteHttpUrl(href: string): boolean {
  return href.startsWith('http://') || href.startsWith('https://');
}

function splitMenuHref(href: string): { pathname: string; search: string } {
  // Cross-app absolute URLs must not be reduced to their pathname. Dashboard on EOR is `/`,
  // and Wallet "Business wallet" is also `/` on the wallet origin — extracting the path would
  // highlight both at once.
  if (isAbsoluteHttpUrl(href)) return { pathname: href, search: '' };

  const queryIndex = href.indexOf('?');
  if (queryIndex === -1) return { pathname: href, search: '' };
  return { pathname: href.slice(0, queryIndex), search: href.slice(queryIndex + 1) };
}

function searchContainsParams(currentSearch: string, requiredSearch: string): boolean {
  if (!requiredSearch) return true;

  const current = new URLSearchParams(
    currentSearch.startsWith('?') ? currentSearch.slice(1) : currentSearch
  );
  const required = new URLSearchParams(requiredSearch);

  for (const [key, value] of required.entries()) {
    if (current.get(key) !== value) return false;
  }

  return true;
}

/** True when this path is the menu URL itself or a deeper segment under it. */
export function pathnameMatchesMenuUrl(pathname: string, url: string): boolean {
  if (isAbsoluteHttpUrl(url)) return false;
  const { pathname: menuPathname } = splitMenuHref(url);
  if (!menuPathname) return false;
  return pathname === menuPathname || pathname.startsWith(`${menuPathname}/`);
}

export function submenuMatchesPathname(
  pathname: string,
  sub: SubmenuPathMatch,
  search = ''
): boolean {
  if (sub.inactive) return false;
  if (sub.isPathActive?.(pathname)) return true;

  const { pathname: subPathname, search: subSearch } = splitMenuHref(sub.url);
  if (!pathnameMatchesMenuUrl(pathname, subPathname)) return false;
  return searchContainsParams(search, subSearch);
}

/**
 * Among sibling submenu URLs that match the pathname, only the longest URL is considered active
 * (e.g. /payroll/eor matches both /payroll and /payroll/eor — only the latter is active).
 */
export function getLongestMatchingSubmenuUrl(
  pathname: string,
  subItems: readonly SubmenuPathMatch[],
  search = ''
): string | undefined {
  const matching = subItems
    .filter((sub) => submenuMatchesPathname(pathname, sub, search))
    .map((sub) => sub.url);
  if (matching.length === 0) return undefined;
  return matching.reduce((a, b) => (b.length > a.length ? b : a));
}

export function isSubmenuItemActive(
  pathname: string,
  subUrl: string,
  subItems: readonly SubmenuPathMatch[],
  search = ''
): boolean {
  const longest = getLongestMatchingSubmenuUrl(pathname, subItems, search);
  return longest !== undefined && subUrl === longest;
}
